import React from "react";

import { type Impulse, useScoped } from "~/tools/impulse";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

import { TimeRangeSelectorContentButton } from "./TimeRangeSelectorContentButton";
import { TimeRangeSelectorSection, type TimeRangeSelectorSectionProps } from "./TimeRangeSelectorSection";

export interface TimeRangeSelectorContentListProps extends TimeRangeSelectorSectionProps {
	timeRange: Impulse<TimeRange>;
	timeRanges: ReadonlyArray<TimeRange>;
}

export const TimeRangeSelectorContentList: React.FC<TimeRangeSelectorContentListProps> = ({
	timeRanges,
	timeRange,
	...props
}) => {
	const timeRangeValue = useScoped(timeRange);

	return (
		<TimeRangeSelectorSection {...props}>
			<div className="space-y-2">
				{timeRanges.map((item) => (
					<TimeRangeSelectorContentButton
						key={item.toString()}
						onClick={() => timeRange.setValue(item)}
						selected={timeRangeValue.isEqual(item)}
						timeRange={item}
					/>
				))}
			</div>
		</TimeRangeSelectorSection>
	);
};
